
import request from "@/utils/request";

export function roleGetAllForDropdown(params) {
    return request({
        url: "/api/services/app/Role/GetAllForDropdown",
        method: "GET",
        params
    });
}

export function roleCreate(data) {
    return request({
        url: "/api/services/app/Role/Create",
        method: "POST",
        data
    });
}

export function roleUpdate(data) {
    return request({
        url: "/api/services/app/Role/Update",
        method: "PUT",
        data
    });
}

export function roleDelete(params) {
    return request({
        url: "/api/services/app/Role/Delete",
        method: "DELETE",
        params
    });
}



// WEBPACK FOOTER //
// ./src/api/role.js